import React, { useState, useEffect } from 'react';
import { Header, Footer, Form, Blog, Stats, Reviews } from '../components/common';
import {
  Banner,
  Courses,
  ReasonsSection,
  PhotoSlider,
  UpcomingBatches,
} from '../components/homepage';
import { homePageContent } from '../content/homePage';
import courseData from '../data/course.json';
import { useContactForm } from '../utils/contactForm';
import bannerFounderImage from '../images/founder/ceo-img.png';
import imageRightBannerImg from '../images/founder/banner-founder-img.png';

const Home = () => {
  const [taglineVisible, setTaglineVisible] = useState(false);
  const [empowerTextVisible, setEmpowerTextVisible] = useState(false);
  const [taglineTextVisible, setTaglineTextVisible] = useState(false);
  const { submitStatus: formStatus, handleSubmit: handleFormSubmit, errorMessage: formErrorMessage } = useContactForm(
    'Something went wrong. Please try again or use the Contact page.'
  );
  const { banner, tagline, courses, blog, reviews: reviewsContent, form } = homePageContent;
  const empowerText = 'Infinite Skills. Real Impact';

  useEffect(() => {
    const t1 = setTimeout(() => setTaglineVisible(true), 400);
    const t2 = setTimeout(() => setEmpowerTextVisible(true), 900);
    const t3 = setTimeout(() => setTaglineTextVisible(true), 900);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  return (
    <>
      <div className="hero-gradient-wrap">
        <Header ctaText="Join Community" ctaPath="#courses" />
        <Banner
          dark
          title={banner.title}
          subtitle={banner.subtitle}
          ctaLink={banner.ctaLink}
          demoCtaText={banner.demoCtaText}
          tags={banner.tags}
          companiesText={banner.companiesText}
          imageRight={bannerFounderImage}
          imageRightBanner={imageRightBannerImg}
        />
      </div>
      <main>
        <section
          className={`home-empower ${taglineVisible ? 'home-empower-visible' : ''}`}
          aria-label="Infinite Skills. Real Impact"
        >
          <div className="home-empower-inner">
            <span className={`home-empower-text ${empowerTextVisible ? 'home-empower-text-visible' : ''}`}>
              {empowerText.split('').map((char, i) => (
                <span
                  key={i}
                  className="home-empower-char"
                  style={{ transitionDelay: `${i * 55}ms` }}
                  aria-hidden="true"
                >
                  {char === ' ' ? '\u00A0' : char}
                </span>
              ))}
            </span>
          </div>
        </section>

        {/* home animation text */}
        {/* <section
          className={`home-tagline ${taglineVisible ? 'home-tagline-visible' : ''}`}
          aria-label="Our mission"
        >
          <div className={`home-tagline-inner ${taglineTextVisible ? 'home-tagline-inner-visible' : ''}`}>
            {tagline.map((line, lineIndex) => {
              let charIndex = tagline.slice(0, lineIndex).join('').length;
              return (
                <p key={lineIndex} className="home-tagline-line">
                  {line.split('').map((char) => {
                    const i = charIndex++;
                    return (
                      <span
                        key={i}
                        className="tagline-char"
                        style={{ transitionDelay: `${i * 35}ms` }}
                        aria-hidden="true"
                      >
                        {char === ' ' ? '\u00A0' : char}
                      </span>
                    );
                  })}
                </p>
              );
            })}
          </div>
        </section> */}
        <Stats />
        <UpcomingBatches
          title="Upcoming Batches"
          batches={courseData.upcomingBatchesHome || []}
        />
        <Courses title={courses.title} subtitle={courses.subtitle} />
        {/* <FeatureSection sectionHeading={featureSection.sectionHeading} /> */}
        <ReasonsSection />
        
        <PhotoSlider />
        <Reviews
          title={reviewsContent?.title}
          ratingLabel={reviewsContent?.ratingLabel}
          reviewCountLabel={reviewsContent?.reviewCountLabel}
          introText={reviewsContent?.introText}
        />
        <Blog title={blog.title} />
        <Form
          title={form.title}
          subtitle={form.subtitle}
          onSubmit={handleFormSubmit}
          submitStatus={formStatus}
          errorMessage={formErrorMessage}
        />
      </main>
      <Footer />
    </>
  );
};

export default Home;
